import React from 'react';
import ImageCellView from './ImageCell';
import DeleteCell from './DeleteCell';
import EditableCell from './EditableCell';
import FilterDropdown from './FilterDropdown';

const DateCell = data => <p>{data.toLocaleString()}</p>;
const ImageCell = src => <ImageCellView src={src} />;
const LinkCell = (link, href) => <a href={href ? href : '#'}>{link}</a>;
const TextCell = text => <p style={{margin: "0px"}}>{text}</p>;
const NumericCell = value => {
  const num = Number(value); 
  if (isNaN(num)) return <p style={{ margin: 0 }}>{value}</p>;

  return (
    <p style={{ margin: 0 }}>
      {num.toLocaleString("hr-HR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}
    </p>
  );
};
const QuantityCell = value => {
  const num = Number(value); 
  if (isNaN(num)) return <p style={{ margin: 0 }}>{value}</p>;

  return (
    <p style={{ margin: 0 }}>
      {num.toLocaleString("hr-HR", {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3
      })}
    </p>
  );
};
 
export {
  DateCell,
  ImageCell,
  LinkCell,
  TextCell,
  EditableCell,
  DeleteCell,
  FilterDropdown,
  NumericCell,
  QuantityCell,
};
